import React from "react";

const GradientDef = props => (
  <defs>
    <linearGradient id={props.gradientId} x2={props.x2} y2={props.y2}>
      {props.colorMap.map(el => (
        <stop offset={el.offset} stopColor={el.color} key={el.color} />
      ))}
    </linearGradient>
  </defs>
);

export default GradientDef;
